<template>
  <div class="pagination_container"
    v-infinite-scroll="loadMore"
    infinite-scroll-disabled="loading"
    infinite-scroll-distance="10">
    <slot :data="data"></slot>
  </div>
</template>

<script>
import { InfiniteScroll } from 'mint-ui'

export default {
  name: 'pagination',
  props: ['data'],
  data () {
    return {
    }
  },
  components: {
  },
  created () {
  },
  methods: {
    loadMore () {
      this.$emit('pagination')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>
